module.exports = __webpack_public_path__ + "static/media/23E09793-E3D0-4D57-ADCC-3377650A05B2.de082b13.bin";